import useBuyNowAlternativePayments from '@/Application/Selectors/buyNow/useBuyNowAlternativePayments';

const formatCLP = (amountInPesos: number): string => {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amountInPesos);
};

export const useFormattedAlternativePayments = () => {
  const { data: alternativePayments, ...rest } = useBuyNowAlternativePayments();

  const totalPriceCenco = alternativePayments?.cencosudCard.centAmount
    ? formatCLP(alternativePayments?.cencosudCard?.centAmount)
    : undefined;

  const totalPrice = alternativePayments?.otherMethod.centAmount
    ? formatCLP(alternativePayments?.otherMethod?.centAmount)
    : undefined;

  const totalPriceCencoPay = alternativePayments?.cencoPay.centAmount
    ? formatCLP(alternativePayments?.cencoPay?.centAmount)
    : undefined;

  return {
    ...rest,
    alternativePayments,
    formattedPrice: {
      totalPriceCenco,
      totalPriceCencoPay,
      totalPrice
    }
  };
};
